import type { IpfModule } from "..";

/**
 * Gets a global variable from the window.
 * @param name The name of the global variable.
 */
export function getGlobal<T>(name: string) {
	return (window as any)[name] as T;
}

/**
 * Sets a global variable on the window.
 * @param name The name of the global variable.
 * @param value The value.
 */
export function setGlobal<T>(name: string, value: T) {
	(window as any)[name] = value;
}

/**
 * Gets the IPF module global variable.
 * @returns Instance of IpfModule.
 */
export function ipf() {
	return getGlobal<IpfModule>("IPF");
}

/**
 * Sets the IPF module global variable.
 * @value Instance of IpfModule.
 */
export function setIpfGlobal(value: IpfModule) {
	setGlobal<IpfModule>("IPF", value);
}